import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const IG_PROFILE = "https://instagram.com/kasamnetcom";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("hn_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem("hn_token")) {
      localStorage.removeItem("hn_token");
      window.location.href = "/giris";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const nf = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const tl = (n) => `${nf.format(n || 0)} ₺`;
export const signedTl = (n) => `${n > 0 ? "+" : ""}${tl(n)}`;
export const todayStr = () => new Date().toLocaleDateString("en-CA");
export const monthStr = () => todayStr().slice(0, 7);
export const fmtDate = (s) =>
  new Date(`${s}T00:00:00`).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric", weekday: "long" });
export const shortDate = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("tr-TR", { day: "2-digit", month: "short" });
export const shiftDate = (s, n) => {
  const d = new Date(`${s}T00:00:00`);
  d.setDate(d.getDate() + n);
  return d.toLocaleDateString("en-CA");
};
